









































import Vue from "vue";
import Component from "vue-class-component";
import { RiskProfileStore, UserStore } from "@/store";

@Component
export default class SessionTimeout extends Vue {
  async mounted() {
    await RiskProfileStore.Reset();
    await UserStore.Logout();
  }

  redirect(e: MouseEvent) {
    e.preventDefault();
    location.reload();
  }

  get companyLogo(): string {
    return UserStore.companyLogo;
  }
}
